import React from 'react';
import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';
import LazyImg from '../../ratio-img';

const DetailImage = ({ width, height, src, alt, styles }) => (
  <ImageWrap styles={styles}>
    <LazyImg
      width={width}
      height={height}
      src={src}
      alt={alt}
      className="js-slide-image"
    />
  </ImageWrap>
);

const ImageWrap = styled.div`
  position: absolute;
  z-index: -1;

  @supports (filter: drop-shadow(24px 19px 49px rgba(0, 0, 0, .18))) {
    filter: drop-shadow(24px 19px 49px rgba(0, 0, 0, .18));
  }

  ${props => props.styles && css`
    ${props.styles}
  `}
`;

DetailImage.propTypes = {
  width: PropTypes.number,
  height: PropTypes.number,
  src: PropTypes.string,
  alt: PropTypes.string,
};

export default DetailImage;
